import { ref, onMounted } from 'vue';
import { defineStore } from 'pinia';
import { fetchCountries } from '@/api/country';

export const useCountriesStore = defineStore('countries', () => {
    const countries = ref([]);

    function getCountry(iso){
        return countries.value.find(country => country.iso === iso);
    }

    function getCountryIso3(iso3){
        return countries.value.find(country => country.iso3 === iso3);
    }

    onMounted(() => {
        fetchCountries()
            .then((response) => {
                countries.value = response;
            })
            .catch((error) => {
                console.error(error);
            })
    });

    return {
        countries, getCountry, getCountryIso3
    };
});